module.exports = __webpack_public_path__ + "static/fonts/AlibabaPuHuiTi-2-105-Heavy.12bbf943.ttf";